import PropTypes from 'prop-types';

/**
 * Container component for page layouts
 * @param {Object} props - Component props
 * @param {string} props.className - Additional CSS classes
 * @param {React.ReactNode} props.children - Container content
 */
const Container = ({ className = '', children, ...props }) => {
  return (
    <div className={`container-custom ${className}`} {...props}>
      {children}
    </div>
  );
};

Container.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
};

export default Container;
